import { Car, GraduationCap, Plane, House, Wallet, Gem } from "lucide-react";

export const GOALS = [
  {
    id: "luxury_car",
    label: "Luxury Car",
    value: 10000000,
    icon: Car,
    accent: "Drive a head-turning machine",
  },
  {
    id: "foreign_education",
    label: "Child's Foreign Education",
    value: 10000000,
    icon: GraduationCap,
    accent: "Ivy League, Oxford, anywhere",
  },
  {
    id: "foreign_vacation",
    label: "Foreign Vacation Every Year",
    value: 10000000,
    icon: Plane,
    accent: "Business class. Always.",
  },
  {
    id: "farm_house",
    label: "Dream Farm House",
    value: 50000000,
    icon: House,
    accent: "Your private retreat",
  },
  {
    id: "passive_income_2",
    label: "Passive Income",
    sub: "₹2L / Month",
    value: 40000000,
    icon: Wallet,
    accent: "Quiet monthly freedom",
    group: "passive_income",
  },
  {
    id: "passive_income_5",
    label: "Passive Income",
    sub: "₹5L / Month",
    value: 100000000,
    icon: Gem,
    accent: "Effortless ultra-comfort",
    group: "passive_income",
  },
];

export const TIME_HORIZONS = [
  { id: "5", label: "Within 5 Years", years: 5, hint: "Sprint to it" },
  { id: "10", label: "5 – 10 Years", years: 10, hint: "A focused decade" },
  { id: "20", label: "10 – 20 Years", years: 20, hint: "Compounding kicks in" },
  { id: "30", label: "20 – 30 Years", years: 30, hint: "Long game advantage" },
];

export const PERSONAS = [
  {
    id: "just_started",
    label: "Just Started Earning",
    hint: "Hello, first paycheck era",
  },
  {
    id: "mid_career",
    label: "Mid Career Professional",
    hint: "Hitting your stride",
  },
  {
    id: "senior",
    label: "Senior Professional",
    hint: "Leadership chapter",
  },
  {
    id: "business_owner",
    label: "Business Owner",
    hint: "Building something of your own",
  },
  {
    id: "near_retirement",
    label: "Near Retirement",
    hint: "The horizon is close",
  },
];

export const PERSONA_INSIGHTS = {
  just_started:
    "Time is your greatest wealth-building advantage. Starting early can dramatically reduce the monthly investment required.",
  mid_career:
    "You are entering your strongest wealth creation years. Consistency now can significantly improve future outcomes.",
  senior:
    "You still have meaningful time to compound wealth. Strategic investing can help bridge the gap to your dream lifestyle.",
  business_owner:
    "Business cash flows combined with disciplined investing can accelerate your path toward financial freedom.",
  near_retirement:
    "Small delays can have a large impact. Prioritizing investments now can help preserve future lifestyle choices.",
};

export const INFLATION_RATE = 0.06;
export const RETURN_RATE = 0.15;
